import { render, staticRenderFns } from "./feedback-mes.vue?vue&type=template&id=4859ff7a&scoped=true&"
import script from "./feedback-mes.vue?vue&type=script&lang=js&"
export * from "./feedback-mes.vue?vue&type=script&lang=js&"
import style0 from "./feedback-mes.vue?vue&type=style&index=0&id=4859ff7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4859ff7a",
  null
  
)

export default component.exports